import React, { useState, useEffect } from 'react'

import Variants from './Variants'
import  { variants } from './Variant'

const DEFAULT_VARIANT_ID = 2

const Component = ({
  resource,
}) => {
  let [selectedVariant, setSelectedVariant] = useState(variants[DEFAULT_VARIANT_ID])

  const flattenParams = param => {
    if (!param.params?.[0]) { return [param] }
    else return [param, ...param.params.flatMap(flattenParams)]
  }
  const flatParams = resource.params
    .flatMap(param => flattenParams(param))

  const anchors = flatParams.map(param => param.anchor)

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    const index = anchors.indexOf(hash)
    if (index < 0) { return }
    const variantId = flatParams[index].variant
    if (variantId < DEFAULT_VARIANT_ID) { return }
    setSelectedVariant(variants[variantId])
  }, [])

  return <Variants 
    resource={resource} 
    selectedVariant={selectedVariant} 
    onChange={(variant) => setSelectedVariant(variant)}
  />
}

export default Component